"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Provider;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Context = _interopRequireDefault(require("./Context"));
var _parse = _interopRequireDefault(require("./experiments/parse"));
var _parseFeatureFlag = _interopRequireDefault(require("./featureFlags/parseFeatureFlag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Provider({
  children,
  cookie,
  cookieff,
  isDelayedTracking,
  trackOrder
}) {
  const pendingCallsRef = _react.default.useRef([]);
  const ninjaInitializedRef = _react.default.useRef(false);
  _react.default.useEffect(() => {
    const oldLaquesisFunctionsCallback = window.laquesisFunctionsCallback;
    if (Object.getOwnPropertyDescriptor(window, 'laquesisFunctionsCallback')?.configurable) {
      delete window.laquesisFunctionsCallback;
    }
    const laquesisFunctionsCallbacks = [];
    Object.defineProperty(window, 'laquesisFunctionsCallback', {
      set: callback => laquesisFunctionsCallbacks.push(callback),
      get: () => () => {
        oldLaquesisFunctionsCallback?.();
        laquesisFunctionsCallbacks.forEach(c => c?.());
        // process pending calls
        while (pendingCallsRef.current.length > 0) {
          const [actionKey, ...parameters] = pendingCallsRef.current.shift();
          const action = window[actionKey];
          action.call(window, ...parameters);
        }
        ninjaInitializedRef.current = true;
      },
      configurable: true
    });
    return () => {
      pendingCallsRef.current = [];
    };
  }, []);
  const isNinjaAvailable = () => ninjaInitializedRef.current && typeof window !== 'undefined' && window.isVariantEnabled && window.isFeatureEnabled;
  const value = _react.default.useMemo(() => ({
    variants: (0, _parse.default)(cookie),
    featureFlags: (0, _parseFeatureFlag.default)(cookieff),
    isVariantEnabled: (experiment, variant, delayedTracking, trackOrder) => {
      if (isNinjaAvailable() && window.isVariantEnabled) {
        window.isVariantEnabled(experiment, variant, delayedTracking, trackOrder);
      } else {
        pendingCallsRef.current.push(['isVariantEnabled', experiment, variant, delayedTracking, trackOrder]);
      }
    },
    isFeatureEnabled: featureFlag => {
      if (isNinjaAvailable() && window.isFeatureEnabled) window.isFeatureEnabled(featureFlag);else pendingCallsRef.current.push(['isFeatureEnabled', featureFlag]);
    },
    isSurveyAvailable: surveyId => {
      if (isNinjaAvailable() && window.isSurveyAvailable) window.isSurveyAvailable(surveyId);else pendingCallsRef.current.push(['isSurveyAvailable', surveyId]);
    },
    laquesisShowSurvey: surveyId => {
      if (isNinjaAvailable() && window.laquesisShowSurvey) window.laquesisShowSurvey(surveyId);else pendingCallsRef.current.push(['laquesisShowSurvey', surveyId]);
    },
    isDelayedTracking: isDelayedTracking,
    trackOrder: trackOrder
  }), [cookie, cookieff, isDelayedTracking, trackOrder]);
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: value
  }, children);
}
Provider.propTypes = {
  children: _propTypes.default.node,
  cookie: _propTypes.default.string,
  cookieff: _propTypes.default.string,
  isDelayedTracking: _propTypes.default.func,
  trackOrder: _propTypes.default.number
};